import catLogo from '@/assets/cat_logo.png'
import perkinsLogo from '@/assets/perkins_logo.jpg'
import { getMediaState } from '@/features/media/slice'
import { useAppSelector } from '@/redux/hooks'

export default () => {
  const { isPerkins } = useAppSelector(getMediaState)

  if (isPerkins) {
    return <img src={perkinsLogo} alt="Perkins Logo" width="112px" />
  } else {
    return <img src={catLogo} alt="Caterpillar Logo" width="64px" />
  }
}
